import { useTranslation } from "@impero-com/common/utils/i18n";

import { useEntitiesQuery } from "org/entities/queries/useEntitiesQuery";

import { MultipleOptionFilterSelect } from "./MultipleOptionFilterSelect";

interface EntitiesFilterProps {
    value: number[];
    onChange: (value: number[]) => void;
}
export function EntitiesFilter({ value, onChange }: EntitiesFilterProps) {
    const { t } = useTranslation();
    const { data: entities } = useEntitiesQuery({
        all: false,
        scope: "control",
    });
    const hasEntities = entities.content.length > 0;

    if (!hasEntities) {
        return null;
    }

    const options = entities.content.map(({ resource: { id, name } }) => ({
        label: name,
        value: id,
    }));
    const availableIds = new Set(options.map((option) => option.value));
    const filteredValue = value.filter((id) => availableIds.has(id));

    return (
        <MultipleOptionFilterSelect
            options={options}
            placeholder={t("Dashboard_EntityFilter_Placeholder")}
            value={filteredValue}
            onChange={(selected) => onChange(selected as number[])}
            minWidth={300}
        />
    );
}
